import axios from "axios";

export const POST_FETCH_DATA = 'POST_FETCH_DATA';
export const POST_DONE = 'POST_DONE';
export const POST_PENDING = 'POST_PENDING';
export const POST_ERROR = 'POST_ERROR';

export const fetchPosts = () => async dispatch => {
    dispatch({type: POST_PENDING});
    try {
        const token = sessionStorage.getItem("authorizationToken");
        const response = await axios.post('/api/posts', {
            queryParams: {
                orderBy: "last_updated",
                order: "DESC"
            },
            returnValues: ["id", "title", "body", "created_in", "last_updated", "last_updated_by"]
        },{headers: {Authorization: `Bearer ${token}`}});

        if (response) {
            dispatch({type: POST_FETCH_DATA, payload: response.data});
        }
        dispatch({type: POST_DONE});
    } catch (err) {
        dispatch({type: POST_ERROR});
    }
};

export const addNewPost = values => async dispatch => {
    try {
        const token = sessionStorage.getItem("authorizationToken");
        const response = await axios.post('/api/posts/add', {
            title: values.title,
            body: values.body
        },{headers: {Authorization: `Bearer ${token}`}});

        if (response) {
            return response.status;
        }
        dispatch({type: POST_DONE});
    } catch (err) {
        dispatch({type: POST_ERROR});
    }
};

export const editPost = values => async dispatch => {
    try {
        const token = sessionStorage.getItem("authorizationToken");
        const response = await axios.post('/api/posts/update', {
            id: values.id,
            title: values.title,
            body: values.body
        },{headers: {Authorization: `Bearer ${token}`}});

        if (response) {
            return response.status;
        }
    } catch (err) {
        dispatch({type: POST_ERROR});
    }
};

export const deletePost = postId => async dispatch => {
    try {
        const token = sessionStorage.getItem("authorizationToken");
        const response = await axios.post('/api/posts/delete', {
            id: postId
        },{headers: {Authorization: `Bearer ${token}`}});

        if (response) {
            return response.status;
        }
    } catch (err) {
        dispatch({type: POST_ERROR});
    }
};